<template>
  <div class="app-page-container">
    <headerBar :gameID="$store.state.gameID"></headerBar>
    <div class="app-body main-container">

      <div class="account-state"  v-if="$store.state.taskExist "
>
       <p
          class="text-danger"
          v-if="$store.state.taskExist && $store.state.canCancel"
        >
          {{ $t("home.delPendTitle") }}
        </p>
        <p
          class="text-danger"
          v-if="$store.state.taskExist && !$store.state.canCancel"
        >
          {{ $t("deletePend.title") }}
        </p>
        <p v-if="$store.state.taskExist && !$store.state.canCancel">
          {{ $t("deletePend.desc") }}
        </p>
        <p v-if="$store.state.taskExist && $store.state.canCancel">
          {{ $t("home.youHave") }}
          <span class="remain-days">
            {{ day }} {{ $t("home.day") }}, {{ hour }}
            {{ $t("home.hour") }}</span
          >
          {{ $t("home.deleteTip") }}
        </p>
      </div>
      <div class="account-info">
      
        <div class="info-line">
          <span class="title"> {{ $t("common.game") }}</span>
          <!-- {{ $t("login.title") }} -->
          <span class="info">{{ $store.state.gameName }}</span>
        </div>
        <div class="info-line">
          <span class="title">{{ $t("common.playerId") }}</span>
          <span class="info">{{ $store.state.aid }}</span>
        </div>
      </div>
     
      <div
        id="g-recaptcha"
        class="g-recaptcha"
        data-sitekey="6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet"
      ></div>
     
      <!-- 取消删除账户 -->
      <button
        class="game-button warning"
        @click="cancelDel"
        v-if="$store.state.taskExist && $store.state.canCancel"
      >
        {{ $t("home.cancelDelete") }}
      </button>
      <button
        class="game-button primary"
        @click="toDataCopy"
        v-if="state === 3 && !$store.state.taskExist "
      >
        {{ $t("home.requestDataCopy") }}
      </button>
      <!-- 数据请求完成 -->
      <button
        class="game-button warning"
        @click="downLoad"
        v-if="state === 2 && !resquestDataPend"
      >
        <i class="fa fa-download"></i>{{ $t("home.dataCopyReady") }} {{ ctime }}
      </button>

      <!-- 请求数据以后pending -->
      <button
        class="game-button warn"
        @click="$router.push('/RequestDataPend')"
        v-if="state === 1 || resquestDataPend"
      >
        <i class="fa fa-hourglass-half"></i> {{ $t("home.requestPending") }}
      </button>
      <button  class="game-button primary doNotSel" @click="doNotSel" >{{ $t("doNotSell.text1") }}</button>
      <!-- 删除账号 -->
       <button
        class="game-button default"
        @click="judgeJump"
      >
        {{ $t("home.delteJupm") }}
      </button>
      <!-- FAQ -->
      <button class="game-button default" @click="$router.push('./Faq')">
        {{ $t("home.visitFAQ") }}
      </button>
       
      <!--  已经存在数据 且 不存在删号操作时 且 距离请求一天以后(否则现实pending状态) 才能申请新的数据 -->
      <!-- {{$store.state.taskExist}}
      {{$store.state.canCancel}}
      {{resquestDataPend}} -->
      <div
        class="newCopy"
        v-if="state === 2 && !$store.state.taskExist && !resquestDataPend"
      >
        <span> {{ $t("home.requestA") }}</span>
        <a href="javascript:void(0)" @click="toDataCopy">
          {{ $t("home.newCopy") }} </a
        >
        <span>{{ $t("home.new") }}</span>
      </div>
    </div>
    <description></description>
    <footerBar :activeIndex="0" @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
var reCaptchaResponse = "";
import headerBar from "../components/common/header_new";
import footerBar from "../components/common/footer";
import description from "../components/common/description";
import { Toast } from "mint-ui";
var moment = require("moment");
export default {
  data() {
    return {
      state: 0,
      dataSource: {},
      ctime: "",
      day: 0,
      hour: 0,
      resquestDataPend: false,
      grecaptchaFlag:true
    };
  },
  beforeDestroy(){
    this.grecaptchaFlag=false;  // 离开页面时取消人机验证的reset方法请求。规避报错
  },
  mounted() {
    setTimeout(() => {
      this.test();
       this.verify();
    },1000)
   
  },
 
  methods: {
    showLanguage(){
      this.$emit('showLanguage')
    },
    test() {
      if (this.$store.state.autoLogined) {
        this.grecaptchaFlag = false;
        return;
      }
      try {
        window.grecaptcha.render("g-recaptcha", {
        sitekey: "6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet",
        callback: function (response) {
          reCaptchaResponse = response;
        },
      });
      } catch (error) {
        console.log(error)
      }
      
    },
    doNotSel(){
      this.$router.push({name:'DoNotSell'})
    },
    verify() {
      const _this = this;
      // 验证token是否通过
      _this
        .$axios({
          method: "post",
          url: "/privacy/token/verify",
          data: {
            pinToken: _this.$cookie.get("token"),
            ua:navigator.userAgent || ''
          },
        })
        .then((res) => {
          if (res.status === 200 && res.data && res.data.r) {
            _this.$store.state.aid = res.data.r.aid;
            _this.$store.state.pin = res.data.r.pin;
            _this.$store.state.icon = res.data.r.icon;
            _this.$store.state.serviceMail = res.data.r.serviceMail || 'mgs-cs@mattel.com';
            _this.$store.state.gameID = res.data.r.gameID;
            _this.$store.state.gameName = res.data.r.name;
            _this.$store.state.taskExist = res.data.r.taskExist; //是否已经创建过删除任务
            _this.$store.state.dataExist = res.data.r.dataExist; //是否已经创建过删除任务
            _this.$store.state.canCancel = res.data.r.canCancel; //是否可以取消
            _this.$store.state.ctime = res.data.r.ctime; //是否可以取消
            _this.$store.state.doNotSell = res.data.r.doNotSell;
            _this.$store.state.lastCancelTime = res.data.r.lastCancelTime
              ? res.data.r.lastCancelTime
              : 0; //是否可以取消
            // _this.$router.push({ name: "Home" });

            if (_this.$store.state.lastCancelTime) {
              let m1 = moment();
              let m2 = moment(this.$store.state.lastCancelTime * 1000);
              let hours = m2.diff(m1, "hour");
              this.day = Math.floor(hours / 24);
              this.hour = hours % 24;
            }
          }
           this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    judgeJump(){
      // $router.push({ name: 'BeforeDel' })
      if(this.$store.state.taskExist){
        this.$router.push({ name: 'DeletePend' })
      } else if (this.$store.state.pendFlag  || this.$store.state.requestDataState === 1){
          this.$router.push({ name: 'forbiddenRequest' })
      } else {
        this.$router.push({ name: 'BeforeDel' })
      }
    },
    toDataCopy() {
      this.$router.push({ name: 'RequestDataCopy' })
    },
    prepareData() {
      // 请求新数据
      const _this = this; //to rec
      if (!reCaptchaResponse.length && !_this.$store.state.autoLogined) {
        Toast({
          message: this.$t("toast.follow"),
        });
        return false;
      }
      this.$axios({
        method: "post",
        url: "/privacy/prepare/data",
        data: {
          grecaptcha: reCaptchaResponse,
          pinToken: _this.$cookie.get("token"),
          ua:navigator.userAgent || ''
        },
      })
        .then((res) => {
          if (res.status === 200 && res.data.c === 0) {
             _this.$store.state.requestDataState = 1;
            this.verify();
          } else {
            Toast({
              message: res.data.d ? res.data.d : "",
            });
          }
        })
        .catch(() => {
          Toast({
            message: this.$t("toast.error"),
          });
        });
    },
    getData() {
      // 刷新状态
      const _this = this;
      this.$axios({
        method: "post",
        url: "/privacy/get/data",
        data: {
          pinToken: _this.$cookie.get("token"),
          ua:navigator.userAgent || ''
        },
      })
        .then((res) => {
          if (res.status === 200) {
            //请求个人数据
            // 如果 返回code=200013，说明数据还没准备就绪 state:1
            // 如果返回code=0，并且url不为空，说明已经准确就绪，url为下载链接 state:2
            // 如果返回code=0，并且url为空，首次创建数据准备任务 state:3
            if (res.data && res.data.c !== 200013 && res.data && res.data.c !== 0) {
              Toast({
                message: this.$t("toast.error"),
              });
            }
            if (res.data && res.data.c === 200013) {
              _this.state = 1;
            } else if (res.data && res.data.r) {
              _this.dataSource = res.data;
              _this.$store.state.pendFlag =
                res.data && res.data.c === 200013 ? true : false;
              _this.state =
                res.data &&
                res.data.c === 0 &&
                res.data &&
                res.data.r &&
                res.data.r.url
                  ? 2
                  : 3;
              _this.ctime =
                res.data.r && res.data.r.ctime
                  ? moment(res.data.r.ctime * 1000).format("MM/DD/YYYY")
                  : "";
              //  }
              if (res.data.r.ctime) {
                this.$store.state.ctime = res.data.r.ctime;
                this.resquestDataPend =
                  new Date() - this.$store.state.ctime * 1000 <
                  24 * 60 * 60 * 1000
                  // 60 * 1000
                    ? true
                    : false;
                // this.resquestDataPend =false;

                this.$store.state.pendFlag = this.resquestDataPend;
              } else {
                this.$store.state.ctime = 0;
                this.$store.state.pendFlag = false;
                this.resquestDataPend = false;
              }
            } else if (res.data && !res.data.r) {
              _this.state = 3;
              // 表示没有数据请求
              _this.$store.state.dataExist = false; //可以取消
              _this.$store.state.pendFlag = false; //没有状态
            }
            _this.$store.state.requestDataState = _this.state;
            if (this.grecaptchaFlag) {
              window.grecaptcha.reset();
            }
          }
        })
        .catch(() => {
          Toast({
            message: this.$t("toast.error"),
          });
        });
    },
    downLoad() {
      window.location.href = this.dataSource.r.url;
    },

    cancelDel() {
      const _this = this;
      this.$axios({
        method: "post",
        url: "/privacy/cancel/del",
        data: {
          pinToken: _this.$cookie.get("token"),
          ua:navigator.userAgent || ''
        },
      })
        .then((res) => {
          if (res.status === 200) {
            this.verify();
            this.getData();
           
          }
        })
        .catch(() => {
          Toast({
            message: this.$t("toast.error"),
          });
        });
    },
  },
  components: {
    headerBar,
    footerBar,
    description,
  },
};
</script>
<style lang="less" scoped>
.doNotSel{
  font-size: 0.32rem;
}
.account-state{
  background: #FFEBDB;
    padding: 0.32rem  0.64rem;
    border-radius: 0.32rem;
    margin-bottom: 0.42rem;
    color: #666666;
  .remain-days {
    color: #dc3545 !important;
    font-weight: 700;
  }
    .text-danger {
    font-weight: 700;
    margin-bottom: 0.1rem;
  }
    p{
      margin: 0;
    }
   
}
.account-info {
  padding-top: .5rem;
    padding-bottom:.5rem;
    border:1px solid #D5DBE5;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.14);
    border-radius: 0.32rem;
    margin-bottom: 0.42rem;
    display: flex;
    flex-direction: column;
  .info-line {
     margin: 0.18rem 0;
    display: flex;
    padding: 0 0.64rem;
    .title {
      flex: 1;
      font-weight: 700;
      font-size: .42rem;
      color: #818181;
    }
    .info {
      flex: 2;
      font-size:.42rem;
      color: #262626;
      font-weight: 700;

    }
  }
}
.newCopy {
  text-align: center;
  width: 100%;
  margin: 15px 0;
  font-size: .42rem;
  span{
   font-size: .42rem;
  }
  a{
   font-size: .42rem;
  }
  strong {
    color: #4990e2;
  }
}

@media screen and (orientation: landscape) {

 .account-info {
    display: block !important;
    position: absolute;
    left: 20%;
     width: 40%;
    color: #ffffff;
    border: none !important;
    box-shadow: none !important;
    transform: translateX(-50%);
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
      top: 0;
    .info-line {
     margin: 0.32rem 0;
      display: flex;
      padding: 0 0.64rem;
      display: flex;
      word-break: break-all;
      .title {
        color: #ffffff !important;
        font-weight: normal !important;
        text-align: left;
        font-size: 0.42rem;
        min-width: 25%;
      }
      .info {
        margin-left: 0.2rem;
        color: #ffffff !important;
        flex: 2;
        font-size: 0.42rem;
        color: #262626;
        font-weight: 700;
      }
    }
  }
}

</style>